import { ValueOf } from 'type-fest'

const MetaClientCategoryType = {
  paymentMethodBenefit: 'paymentMethodBenefit',
} as const

type MetaClientCategoryType = ValueOf<typeof MetaClientCategoryType>

export { MetaClientCategoryType }
